import { Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';
import Modal from '@components/Modal/Modal';

type Props = {
  open: boolean;
  onClose: () => void;
  onConfirm: () => void;
  chargeType: string;
  isDeleting?: boolean;
};

export const DeleteChargeModal = ({
  open,
  onClose,
  onConfirm,
  chargeType,
  isDeleting = false
}: Props) => {
  const { t } = useTranslation(['charges', 'common']);

  return (
    <Modal open={open} onClose={onClose} maxWidth="sm">
      <Modal.Header
        title={t('charges:deleteChargeModal.title')}
        onClose={onClose}
      />
      <Modal.Content>
        <Typography>
          {t('charges:deleteChargeModal.message', { chargeType })}
        </Typography>
      </Modal.Content>
      <Modal.Footer
        primaryButton={{
          text: isDeleting
            ? t('charges:deleteChargeModal.removing')
            : t('charges:removeCharge'),
          color: 'error',
          variant: 'contained',
          onClick: onConfirm,
          disabled: isDeleting,
          loading: isDeleting
        }}
        secondaryButton={{
          text: t('common:buttons.cancel'),
          onClick: onClose,
          disabled: isDeleting
        }}
      />
    </Modal>
  );
};
